/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ViewInputs */

const en_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const es_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const fr_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

const de_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const ja_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示`)
};

const zh_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看`)
};

const ar_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض`)
};

const id_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat`)
};

const it_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza`)
};

const ru_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть`)
};

const pt_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizar`)
};

const ko_action_view = /** @type {(inputs: Action_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보기`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Action_ViewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_view = /** @type {((inputs?: Action_ViewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ViewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_view(inputs)
	if (locale === "es") return es_action_view(inputs)
	if (locale === "fr") return fr_action_view(inputs)
	if (locale === "de") return de_action_view(inputs)
	if (locale === "ja") return ja_action_view(inputs)
	if (locale === "zh") return zh_action_view(inputs)
	if (locale === "ar") return ar_action_view(inputs)
	if (locale === "id") return id_action_view(inputs)
	if (locale === "it") return it_action_view(inputs)
	if (locale === "ru") return ru_action_view(inputs)
	if (locale === "pt") return pt_action_view(inputs)
	return ko_action_view(inputs)
});